import React from 'react';
import { Typography } from '@mui/material';

/**
 * Account number template
 */
export const AccountTemplate: React.FC<{ account?: string }> = ({ account }) => {
  return (
    <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
      {account || '-'}
    </Typography>
  );
};

export default AccountTemplate;
